import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lc-table-standalone',
  templateUrl: './lc-table-standalone.component.html',
  styleUrls: ['./lc-table-standalone.component.css']
})
export class LcTableStandaloneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
